import { ReactNode, useEffect, useRef, useState } from 'react';

import FontIcon from 'components/icons';

import './styles/field-error-popup.scss';

type FieldErrorPopupProps = {
  children: ReactNode,
}

const FieldErrorPopup = ({ children }:FieldErrorPopupProps) => {

  const timeoutRef = useRef<NodeJS.Timeout | null>(null);
  const [show, setShow] = useState(true);

  useEffect(() => {
    if (show) {
      timeoutRef.current = setTimeout(() => {
        setShow(false);
      }, 3000);
    }

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [show]);

  return (
    <div className={ `errors-tooltip has-icons-left ${!show ? 'is-hidden' : ''}` }>
      <p className="tooltip-inner has-text-danger">
        <span className="has-text-warning tooltip-icon">
          <FontIcon icon="warning" />
        </span>
        <span className="tooltip-text">{children}</span>
      </p>
    </div>
  );
};

export default FieldErrorPopup;
